// Category file management constants shared by the server (validation, bulk
// endpoint skip codes) and the client (archive dialog, per-file failure list).

export const archiveFileReasons = Object.freeze(['Out of Scope', 'Duplicate', 'Uploaded by Mistake', 'Other'])

// Longest category name the create endpoint accepts (trimmed).
export const CATEGORY_NAME_MAX_LENGTH = 100

// Most file ids one bulk archive/move request may carry.
export const BULK_FILE_MAX_IDS = 500

// 409 `code` while a user-visible workflow is pending on an involved category.
export const PENDING_WORKFLOW = 'PENDING_WORKFLOW'

// Per-file skip codes returned by the bulk archive/move endpoints.
export const BULK_FILE_SKIP_CODES = Object.freeze({
  NOT_FOUND: 'NOT_FOUND',
  NOT_IN_CATEGORY: 'NOT_IN_CATEGORY',
  ALREADY_ARCHIVED: 'ALREADY_ARCHIVED',
  ALREADY_IN_CATEGORY: 'ALREADY_IN_CATEGORY',
  WRONG_FOI: 'WRONG_FOI',
  // The file's category is past the file-management stages (bulk archive), or an
  // ACTIVE file's source category is (move) — archived files may be restored
  // regardless of their old category's status.
  STATUS_NOT_ALLOWED: 'STATUS_NOT_ALLOWED'
})
